// @flow
import * as React from "react";
import { useDispatch } from "react-redux";
import { Trans } from "react-i18next";
import classnames from "classnames";
import { Grid, Icon, Segment, Header, Divider, Button, Container } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { removeReminderCreationSucceed } from "modules/Reminder/redux/shortReminders/actions";
import { navigateTo } from "Commons/Modules/routing";
import DashboardRoute from "modules/Dashboard/misc/Routes";

import "./RegistrationSuccess.scss";

type Props = {
  t: typeof TFunction,
  lite?: boolean,
  showLoginMessage?: boolean,
};

let RegistrationSuccessMessage = ({ t, lite, showLoginMessage }: Props): React.Node => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    return () => {
      dispatch(removeReminderCreationSucceed());
    };
  }, [dispatch]);

  if (showLoginMessage) {
    return (
      <Grid stackable centered>
        <Grid.Column width="12" textAlign="center">
          <Icon name="check circle outline" size="huge" color="green" />
          <Header as="h1">
            <Trans i18nKey="auth:confirmationPage.title1">
              <br />
            </Trans>
          </Header>
          <Divider hidden />
          <Divider hidden />
          <p>{t("auth:confirmationPage.subtitle")}</p>
          <Grid.Row width={16}>
            <Container textAlign="center">
              <Link to={DashboardRoute}>
                <Button primary size="big">
                  {t("common:toDashboard")}
                  <Icon name="arrow right" />
                </Button>
              </Link>
            </Container>
          </Grid.Row>
        </Grid.Column>
      </Grid>
    );
  }

  return (
    <Grid stackable relaxed padded centered columns={2} textAlign={"center"} data-cy="registrationSuccessMessage">
      <Grid.Column width={lite ? 16 : 10} textAlign={"center"}>
        <Segment data-cy={"registration_success"} basic>
          <Grid.Row>
            <Icon name={"check circle"} color={"green"} size={"huge"} />
          </Grid.Row>
          <Grid.Row>
            <Header as={"h4"}>{t("auth:registration.onlySmallStep")}</Header>
          </Grid.Row>
          <Grid.Row>
            <Header
              as={"h3"}
              className={classnames(
                "RegistrationSuccessMessage header-margins",
                "RegistrationSuccessMessage lighter-font"
              )}
            >
              {t("auth:registration.emailSent")}
            </Header>
          </Grid.Row>
          {!lite && (
            <Grid.Row>
              <Header as={"h3"} className={"RegistrationSuccessMessage header-margins"}>
                {t("auth:registration.confirmEmail")}
              </Header>
            </Grid.Row>
          )}
          {!lite && (
            <Grid.Row>
              <Header
                className={classnames(
                  "RegistrationSuccessMessage header-margins",
                  "RegistrationSuccessMessage lighter-font"
                )}
                as={"h3"}
              >
                {t("auth:registration.reminderCreated")}
              </Header>
            </Grid.Row>
          )}
          <Grid.Row>
            <div className={"RegistrationSuccessMessage header-margins-more"}>
              <p>{t("auth:registration.missingEmail")}</p>
              <p>
                <Trans t={t} i18nKey="auth:registration.contactCustomerSupport">
                  {/*prettier-ignore*/}
                  <a href="mailto:service@remind.me" className={"RegistrationSuccessMessage green-mailTo"}> </a>
                </Trans>
              </p>
            </div>
          </Grid.Row>
          <Divider hidden />
          <Grid.Row>
            <Button secondary fluid onClick={() => navigateTo(DashboardRoute)}>
              {t("auth:registration.toDashboardButton")}
            </Button>
          </Grid.Row>
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

export default RegistrationSuccessMessage;
